<template>
  <div>
    <div class="title">
      <div>{{ $t("RAM.ALI.database.title") }}</div>
      <div>
        <Button
          type="primary"
          v-hasPermission="[
            'resourceConfigurationManagement:ali:relationalDatabaseServiceResourceAli:update'
          ]"
          :loading="loading"
          @click="update"
          >{{ $t("RAM.common.update") }}</Button
        >
        <Button
          type="primary"
          v-hasPermission="[
            'resourceConfigurationManagement:ali:relationalDatabaseServiceResourceAli:export'
          ]"
          :loading="modal_loading"
          @click="exportList"
          >{{ $t("common.export") }}</Button
        >
      </div>
    </div>
    <relational-database-service-resource-search
      ref="child"
    ></relational-database-service-resource-search>
    <table-relational-database-service-resource></table-relational-database-service-resource>
    <export ref="exportChild"></export>
  </div>
</template>

<script>
import RelationalDatabaseServiceResourceSearch from "../rds/RelationalDatabaseServiceResourceSearch";
import TableRelationalDatabaseServiceResource from "../rds/TableRelationalDatabaseServiceResource";
import Export from "../../ali/Export";
export default {
  name: "RelationalDatabaseServiceResourceAli",
  components: {
    RelationalDatabaseServiceResourceSearch,
    TableRelationalDatabaseServiceResource,
    Export
  },
  data() {
    return {
      modal_loading: false,
      loading: false
    };
  },
  methods: {
    update: function() {
      this.loading = true;
      this.$api.resourceManagement
        .updateResource({
          companyId: this.$refs.child.companyId,
          resourceManagement: 1,
          accountType: 1
        })
        .then(res => {
          this.loading = false;
          setTimeout(() => {
            this.$Message.success(this.$t('common.updateSuccess'));
          }, 1000);
        });
    },
    //导出
    exportList: function() {
      var exportDTO = {
        companyId: this.$refs.child.companyId,
        accountName: this.$refs.child.accountNameSearchKey,
        dbInstanceName: this.$refs.child.nameSearchKey,
        engineType: this.$refs.child.engineSearchKey,
        dbInstanceType: this.$refs.child.typeSearchKey,
        state: this.$refs.child.state
      };
      this.modal_loading = true;
      this.$Message.loading({
        duration: 0,
        content: this.$t('common.exporting')
      });
      // 下载Excel 文件
      this.$api.resourceManagement.exportAliyunDatabase(exportDTO).then(res => {
        let fileName = this.$t('RAM.export.database');
        let blob = new Blob([res.data], { type: "application/x-xls" });
        if (window.navigator.msSaveOrOpenBlob) {
          navigator.msSaveBlob(blob, fileName);
        } else {
          var link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = fileName;
          link.click();
          window.URL.revokeObjectURL(link.href);
        }
        this.modal_loading = false;
        this.$Message.destroy();
        this.$Message.success(this.$t('common.exportSuccess'));
      });
    }
  }
};
</script>

<style scoped>
.title {
  width: 100%;
  font-size: 13px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 15px 0px 0px 4px;
  overflow: hidden;
  font-weight: 600;
}
.title > div:nth-child(1) {
  float: left;
}
.title > div:nth-child(2) {
  float: right;
  margin-top: -6px;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/ali/rds/RelationalDatabaseServiceResourceAli.vue